import { render, staticRenderFns } from "./DashboardOld.vue?vue&type=template&id=a2413dc0&scoped=true&"
import script from "./DashboardOld.vue?vue&type=script&lang=js&"
export * from "./DashboardOld.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOld.vue?vue&type=style&index=0&id=a2413dc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2413dc0",
  null
  
)

export default component.exports